/* eslint-disable i18next/no-literal-string */
import { useSyncExternalStore } from "react";
import DetailItem from "@/features/diagnostics/components/lib/detail-item.tsx";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import { DiagnosticsEmpty } from "../lib/diagnostics-card.tsx";

export default function TrackingEventList() {
    const trackingEvents = useSyncExternalStore(DiagnosticsStore.subscribe, () => DiagnosticsStore.trackingEvents);

    if (trackingEvents.length === 0) {
        return <DiagnosticsEmpty>No tracking events recorded!</DiagnosticsEmpty>;
    }

    return (
        <ul className="diagnostics-list">
            {trackingEvents.map((event) => (
                <DetailItem key={event.id} timestamp={event.timestamp} name={event.event} data={event.data} />
            ))}
        </ul>
    );
}
